import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PersonSearchService } from '../_services/person-search.service';
import { LocalStorageService } from '../_services/local-storage.service';
import { LoginService } from '../_services/login.service';
import { TransactionService } from '../_services/transaction.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-default-location-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './default-location-modal.component.html',
  styleUrls: ['./default-location-modal.component.scss']
})
export class DefaultLocationModalComponent implements OnInit {

  continentsList: any;
  default_continent: string = null;
  @Output() modalDismissEvent: EventEmitter<any> = new EventEmitter();
  continentErrorMessage: string = "";

  constructor(private personSearchService: PersonSearchService, private localStorageService: LocalStorageService, private loginService: LoginService,
    private transactionService: TransactionService, private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.getPreferredContinents();
  }

  getPreferredContinents() {
    this.personSearchService.getPreferredContinents().subscribe((res:any)=>{
      this.continentsList = res.data;
    })
  }

  saveChanges() {
    if(!this.default_continent){
      this.continentErrorMessage = "Please select location prefernce";
      return;
    }
    let payload = {
      preferredsearchcontinent: this.default_continent,
      usernumber: this.localStorageService.getItem('usernumber'),
    }
    this.loginService.updateuserDetails(payload).subscribe((res:any)=>{
      if(res.status == "success"){
        this.localStorageService.setItem('defaultContinent', this.default_continent);
        // force past the cache so access()/localStorage reflect the new continent immediately
        // instead of waiting up to 5 minutes for the next natural refresh
        this.transactionService.updateAccessDetailsForCurrentUser(true).subscribe();
        this.modalDismissEvent.emit('success');
        this.modalService.dismissAll();
      }
    })
  }

}
